import { useEffect, useState } from "react";
import { apiHelper } from "../../lib/ApiHelper";
import Dropdown from 'react-bootstrap/Dropdown';
import '../MainBox.css';
import DatePicker from 'react-datepicker';

export default function MetadataUS(props) {
    const [maxAgendaDate, setMaxAgendaDate] = useState(null);
    const [maxDate, setMaxDate] = useState(null);
    const [titleSelected, setTitleSelected] = useState(null);
    const [updatingTitleStatus, setUpdatingTitleStatus] = useState(false);
    const [AgendaDate, setAgendaDate] = useState(null);
    const [ExpirationDate, setExpirationDate] = useState(null);
    const [copied, setCopied] = useState(false);

    function formatNumberWithCommas(number) {
        if (isNaN(number)) {
            return '';
        }
        // Convert number to string
        let str = number.toString();

        // Split the number into integer and decimal parts
        let parts = str.split(".");

        // Format integer part with commas
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        // If decimal part exists and has one digit, add a trailing zero
        if (parts[1] && parts[1].length === 1) {
            parts[1] += "0";
        }

        // Join integer and decimal parts and return
        return parts.join(".");
    }


    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: props.metaData ? (props.metaData.currency || 'USD') : 'USD',
    });

    const titleAlert = (message, className = 'info', id) => {
        const statusAlertElement = document.getElementById(id);
        if (statusAlertElement) {
            statusAlertElement.textContent = message ?? "";
            statusAlertElement.className = className;
        }
    }

    const currencyFormat = (curr) => {
        if (isNaN(curr)) {
            return '';
        }
        if (curr) {
            return USDollar.format(curr);
        }
        return '';
    }



    const validateDate = (dateString) => {
        if (!dateString)
            return false;
        var date = new Date(dateString);
        if (isNaN(date.getTime())) return false;
        else { return true; }

    }

    const expirationDateSelect = async (value) => {
        if (!validateDate(value))
            return;
    /*    const dateToSave = new Date(value);

        const data = new Date(dateToSave.setHours(0, 0, 0, 0));*/

        const date = new Date(value);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
          const data = `${year}-${month}-${day}`;
        const dataToShow = new Date(date.setHours(0, 0, 0, 0));
      

        setExpirationDate(dataToShow);
        titleAlert("Updating Expiration Date...", "update", 'title-update-alert');
        try {
            setUpdatingTitleStatus(true);
            const payload = await setExpirationPayLoad(data);
            props.setMetaData(prev => ({
                ...prev,
                statusId:  props?.metaData?.statusId,
                expirationDate: props?.metaData?.statusId === 23 ? dataToShow : null,
                agendaDate: null }));
          
            const res = await apiHelper.inventoryPostCall("manageISBNStatus", payload);
            if (res == true) {


                titleAlert("ExpirationDate updated.", "success", 'title-update-alert');
            } else {
     
                titleAlert("Update Failed.", "error", 'title-update-alert');
            }
        } catch (error) {
            props.fetchMetaData();
            titleAlert('Update Failed.', "error", 'title-update-alert');
            console.error(error);
        } finally {
            setUpdatingTitleStatus(false);
            setTimeout(() => titleAlert('', 'info', 'title-update-alert'), 2000);
        }
    }
    const agendaDateSelect = async (value) => {

        if (!validateDate(value))
            return;
   /*     const dateToSave = new Date(value);

        const data = new Date(dateToSave.setHours(0, 0, 0, 0));*/
   
        const date = new Date(value);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
      const data = `${year}-${month}-${day}`;
      //  const data = new Date(year,month,day);
        const dataToShow = new Date(date.setHours(0, 0, 0, 0));
        setAgendaDate(dataToShow);
        titleAlert("Updating Agenda Date...", "update", 'title-update-alert');
        try {
            setUpdatingTitleStatus(true);
            const payload = await setAgendaPayLoad(data);

            props.setMetaData(prev => ({ ...prev, statusId: props?.metaData?.statusId, agendaDate: (props?.metaData?.statusId === 16 ) ? dataToShow : null}));
     
            const res = await apiHelper.inventoryPostCall("manageISBNStatus", payload);
            if (res == true) {


                titleAlert("AgendaDate updated.", "success", 'title-update-alert');
            } else {
              
                titleAlert("Update Failed.", "error", 'title-update-alert');
            }
        } catch (error) {
            titleAlert('Update Failed.', "error", 'title-update-alert');
            console.error(error);
            props.fetchMetaData();
        } finally {
            setUpdatingTitleStatus(false);
            setTimeout(() => titleAlert('', 'info', 'title-update-alert'), 2000);
        }
    }


    const setTitlePayLoad = async (id) => {
        const payload = {
            isbnList: [props?.metaData?.isbn],
            statusId: id,
            upn: props.upn,
            AgendaDate: (id === 16 ) ? (props?.metaData && props.metaData?.agendaDate ? props.metaData?.agendaDate : null) : null,
            ExpirationDate: (id === 23) ? (props?.metaData && props.metaData?.expirationDate ? props.metaData?.expirationDate : null) : null
        }
        return payload;
    }
    const setAgendaPayLoad = async (data) => {
        const payload = {
            isbnlist: [props?.metaData?.isbn],
            statusid:  props?.metaData?.statusId,
            upn: props.upn,
            AgendaDate: (props?.metaData?.statusId === 16) ? data : null,
            ExpirationDate: null
        }
        return payload;
    }
    const setExpirationPayLoad = async (data) => {
        const payload = {
            isbnList: [props?.metaData?.isbn],
            statusId: props?.metaData?.statusId,
            upn: props.upn,
            AgendaDate:null,
            ExpirationDate: (props?.metaData?.statusId === 23) ? data : null
        }
        return payload;
    }
    const selectTitle = async (id) => {
        titleAlert("Updating status...", "update", 'title-update-alert');
        try {
            setUpdatingTitleStatus(true);
            const payload = await setTitlePayLoad(id);

            props.setMetaData(prev => ({
                ...prev,
                statusId: id,
                agendaDate: (id == 16 ) ? AgendaDate: null,
            }));
        
            //check if date is null or empty, update only if they are not null
            if (([16].includes(id) && (AgendaDate == null || AgendaDate == "")) || ((id === 23) && (ExpirationDate == null || ExpirationDate == ""))) {
                titleAlert((id === 23) ? 'Select Expiration Date' : 'Select Agenda Date', "update", 'title-update-alert');
                return;
            } else {
                const res = await apiHelper.inventoryPostCall("manageISBNStatus", payload);

                if (res == true) {
                    titleAlert("Status updated successfully.", "success", 'title-update-alert');
                } else {

                    titleAlert("Update Failed.", "error", 'title-update-alert');
                }
            }
        } catch (error) {
            titleAlert('Update Failed.', "error", 'title-update-alert');
            console.error(error);
            props.fetchMetaData();
        } finally {
            setUpdatingTitleStatus(false);
            setTimeout(() => titleAlert('', 'info', 'title-update-alert'), 2000);
        }
    }

    const showFormatDate = (dateString) => {
        if (dateString && dateString != '0001-01-01T00:00:00') {
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const formattedDate = `${month}/${day}/${year}`;
            return formattedDate;
        }
        return null;
    }

    const isbnStringList = () => {
        if (props?.isbns != undefined && props?.isbns != null && props?.isbns.length > 0) {
            const isbnlist = props.isbns.map(i => i.isbn);
            if ((isbnlist?.length ?? 0) == 0) { return ''; }
            return isbnlist.join(',');
        }
    }

    const copyToClipboard = (check) => {
        if (check == null) return;
        const baseURL = window.location.origin;
        const isbnString = check ? isbnStringList() : props.metaData.isbn;
        navigator.clipboard.writeText(`${baseURL}/overview?isbns=${isbnString}`).then(() => {
            setCopied(true);
            setTimeout(() => {
                setCopied(false);
            }, 2000); // Reset copied state after 2 seconds
        }).catch(err => {
            console.error('Failed to copy: ', err);
        });
    }

    const createMailUrl = (check) => {
        const baseURL = window.location.origin;
        const isbnString = check ? isbnStringList() : props.metaData.isbn;
        return `${baseURL}/overview?isbns=${isbnString}`
    }

    const setTitleData = () => {
        if (props?.metaData?.statusId) {
            let item = props?.fullList.find(i => i.statusId == props.metaData.statusId);
            if (item)
                setTitleSelected(`${item.status}${item.subStatus && item.subStatus != '' ? ("-" + item.subStatus) : ''}`);
            else setTitleSelected(null);
        } else {
            setTitleSelected(null);
        }
    }


    const setCurrDate = () => {
        const currentDate = new Date();

        // Add 90 days to the current date
        const maxDate = new Date();
        const maxAgendaDate = new Date();
        maxDate.setDate(currentDate.getDate() + 90);
        maxAgendaDate.setDate(currentDate.getDate() + 45);

        // Format the date to a readable format (optional)
        const formattedMaxDate = maxDate.toISOString().split('T')[0];
        const formattedMaxAgendaDate = maxAgendaDate.toISOString().split('T')[0];
        setMaxDate(formattedMaxDate);

        setMaxAgendaDate(formattedMaxAgendaDate);
    }

    useEffect(() => {
        setCurrDate();
    }, []);

    useEffect(() => {
        if (props?.fullList && props?.fullList.length > 0) setTitleData();
    
    }, [props?.fullList])

    useEffect(() => {
    
        if (props?.titleList.length > 0 && props.metaData) {
            setAgendaDate(props?.metaData?.agendaDate ?? null);
            setExpirationDate(props?.metaData?.expirationDate ?? null);
         
        } else {
            setAgendaDate(null);
            setExpirationDate(null);
           
        }
      
        setTitleData();
    }, [props.metaData])


    return (
        <>

            <div className={`metadata-container mb-2 ${props?.isShrunk ? 'metadata-container-shrink' : ''}`}>
                <table className="metaData-table">
                    {!props?.isMetaLoading && props?.metaData != null ? ( props?.metaData.access === 'd' ? <tbody  >
                        <tr className="mb-1">
                            <td key="title-image" colSpan="3" rowSpan="2" style={{ width: "auto", minWidth: "80px", maxWidth: "150px", paddingLeft: "0" }}></td>


                            <td rowSpan="2" colSpan="2">
                                <div className="metaData-detail">&nbsp;</div>
                            </td>
                            <td rowSpan="2" colSpan="5">
                                <div className="metaData-detail" style={{ color: "red", margin: "auto", fontSize: "20px" }}>Access Denied</div>
                            </td>
                        </tr>
                    </tbody> :< tbody >
                        <tr className="mb-1">
                            <td key="title-image" colSpan="3" rowSpan="2" style={{ width: "auto", minWidth: "80px", maxWidth: "150px", paddingLeft: "0" }}>{(props?.src === '' || props?.error) ? (
                                <p >Image not available</p>
                            ) :
                                <img className="title-image" alt="cover Image" src={props?.src} ></img>}</td>
                            {props.metaData != null && !props.isMetaLoading ? (<>
                                <td>
                                    <div className="metaData-detail">
                                        <div>
                                            <span className="meta-title">Title</span> <p>{props.metaData.title} </p>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="metaData-detail ">
                                        <div><span className="meta-title">ISBN</span>
                                            <span className="dropdown">
                                                <span className="dropbtn ml-2" ><i className="fa fa-share-alt ml-1" aria-hidden="true"></i></span>
                                                <div className="dropdown-content">
                                                    <div className="nested-dropdown">
                                                        <a>Share current title selected</a>
                                                        <div className="dropdown-content-2">
                                                            <a href={'https://teams.microsoft.com/l/chat/0/0?users=&message=' + `Check out ${encodeURIComponent(createMailUrl(false))} in the Inventory Hub. &uid=${Date.now()}`} target="_blank" >
                                                                <img src='/msteams-40x40.png' className='teams-icon mr-1' border='0' />Share on Teams</a>
                                                            <a onClick={() => copyToClipboard(false)}><i className="fa fa-clipboard mr-2" aria-hidden="true" title="Copy Link" > </i> Copy Link {copied ? 'Copied!' : ''}</a>
                                                            <a href={'mailto:?subject=' + `Please take a look at ${props.metaData.isbn} in the Inventory Hub.&body=Hi, I would like to discuss ISBN  : ${createMailUrl(false)}`}><i className="fa fa-envelope-o mr-1" aria-hidden="true"></i> Send Email</a>
                                                        </div>
                                                    </div>
                                                    <div className="nested-dropdown">
                                                        <a >Share list of titles selected</a>
                                                        <div className="dropdown-content-2">
                                                            <a href={'https://teams.microsoft.com/l/chat/0/0?users=&message=' + `Check out  ${encodeURIComponent(createMailUrl(true))}  in the Inventory Hub. &uid=${Date.now()}`} target="_blank">
                                                                <img src='/msteams-40x40.png' className='teams-icon mr-1' border='0' />Share on Teams</a>
                                                            <a onClick={() => copyToClipboard(true)}><i className="fa fa-clipboard mr-2" aria-hidden="true" title="Copy Link" > </i> Copy Link {copied ? 'Copied!' : ''}</a>
                                                            <a href={'mailto:?subject=' + `Please take a look at this list in the Inventory Hub.&body=Hi, I would like to discuss ISBN  ${createMailUrl(true)}`}><i className="fa fa-envelope-o mr-1" aria-hidden="true"></i> Send Email</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </span>
                                            <p>{props.metaData.isbn}</p>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="metaData-detail">
                                        <div>
                                            <span className="meta-title" title="Format Code">FMT</span> <p>{props.metaData.format}</p>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="metaData-detail">
                                        <div>
                                            <span className="meta-title" title="Sales Status Code">SS</span> <p>{props.metaData.salesstatus ? props.metaData.salesstatus : <>&nbsp;</>}</p>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="metaData-detail">
                                        <div>
                                            <span className="meta-title" title="Returns Disposition">RTS</span> <p>{props.metaData.rts ? props.metaData.rts : <>&nbsp;</>}</p>
                                        </div>
                                    </div>
                                </td>
                                < td > <div className="metaData-detail">
                                    <div>
                                        <span className="meta-title" title="Short Run Indicator">SR</span> <p>{props.metaData.shrtrunind ? props.metaData.shrtrunind : <>&nbsp;</>}</p>
                                    </div>
                                </div>
                                </td>
                                <td>
                                    <div className="metaData-detail">
                                        <div>
                                            <span className="meta-title" title="Title Block">Block</span> <p>{props.metaData.titleBlock ? props.metaData.titleBlock : <>&nbsp;</>}</p>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="metaData-detail">
                                        <div>
                                            <span className="meta-title" title="Country of Origin">COO</span> <p>{props.metaData.countryofOrigin ? props.metaData.countryofOrigin : <>&nbsp;</>}</p>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="metaData-detail">
                                        <div>
                                                <span className="meta-title" title="Carton/Pallet count">Crtn/Plt</span> <p>{props.metaData.cartonQty ? props.metaData.cartonQty : <>&nbsp;</>}</p>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="metaData-detail">
                                        <div>
                                            <span className="meta-title" title="Sales Rights">Rights</span> <p>{props.metaData.salesrestrdesc ? props.metaData.salesrestrdesc : <>&nbsp;</>}</p>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="metaData-detail ">
                                        <div>
                                            <span className="meta-title" title="Division Code">Div</span> <p>{props.metaData.divisionCode} </p>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="metaData-detail ">
                                        <span className="meta-title">Imprint Name</span> <p>{props.metaData.imprint} </p>
                                    </div>
                                </td>
                                <td>
                                    <div className="metaData-detail">
                                        <span className="meta-title" title="Series">Series</span>  <p>{props.metaData.series}&nbsp;</p>
                                    </div>
                                </td>
                                <td>
                                    <div className="metaData-detail">
                                        <span className="meta-title" title="On Sale Date">OnSale Date</span>  <p>{showFormatDate(props.metaData.onsaleDate)}&nbsp;</p>
                                    </div>
                                </td>



                                <td>
                                    <div className="metaData-detail ">
                                        <div className="mb-2 mt-1">
                                            {props.metaData.statusId ? <>
                                                <span className="meta-title" title="status">Title Status</span>
                                                <p>
                                                    <Dropdown className="drpdwn-ttl">
                                                            <Dropdown.Toggle className="drp-dwn-toggle" disabled={updatingTitleStatus || !props.isEditable || props?.metaData?.access != "m"}>
                                                            {titleSelected || 'Select Title...'}
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu >
                                                            {props?.titleList.map((item) => {
                                                                return (<Dropdown.Item
                                                                    onClick={() => selectTitle(item.statusId)}>{item.status}{item.subStatus && item.subStatus != "" ? ("-" + item.subStatus) : ""}</Dropdown.Item>)
                                                            })}
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                    <div className="title-update-alert" id="title-update-alert"></div>
                                                </p>
                                            </>
                                                :
                                                <></>}
                                        </div>
                                    </div>
                                </td>
                            </>)
                                :
                                <>
                                    <td rowSpan="2" colSpan="2">
                                        <div className="metaData-detail">&nbsp;</div>
                                    </td>
                                    <td rowSpan="2" colSpan="5">
                                        <div className="metaData-detail" style={{ color: "red", margin: "auto", fontSize: "20px" }}>{props.isMetaLoading ? "Loading Metadata..." : "No Data Available..."}</div>
                                    </td></>
                            }
                        </tr>
                        <tr className="mb-1">
                            {props.metaData != null && !props.isMetaLoading ? (<>
                                <td>
                                    <div className="metaData-detail">
                                        <div><span className="meta-title">Author</span> <p> {props.metaData.author} </p></div>
                                    </div>
                                </td>
                                <td>
                                    <div className="metaData-detail ">
                                        <div>
                                            <span className="meta-title">Active Batch</span> <p className='cursor-pointer' title={props.metaData?.bisac1}>{props.metaData.activeBatch}</p>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="metaData-detail">
                                        <span className="meta-title" title="Suggested Retail Price">SRP</span>
                                        <p>{props.metaData.srp ?
                                            <a style={{ fontWeight: "600", fontSize: props?.isShrunk ?"10px" :"13px", cursor: "pointer", color: (props.metaData?.srp - props.metaData?.currentPrice) > 0.99 ? "red":"#0D6EFD" }} target="_blank" href={`https://randomhouse.app.box.com/folder/248706230143/search?query=${props.metaData?.isbn}`}> {currencyFormat(props.metaData.srp)}</a>
                                            : <>&nbsp;</>}</p>
                                    </div>
                                </td>
                                <td colSpan="2">
                                    <div className="metaData-detail">
                                        <div>
                                            <span className="meta-title" title="Last UpPrice">Last UpPrice</span> <p>{showFormatDate(props.metaData.lastUpPrice)}&nbsp;</p>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="metaData-detail">
                                        <div>
                                            <span className="meta-title" title="Highest available print numbers">Print #</span> <p>{props.metaData.print ? props.metaData.print : <>&nbsp;</>} </p>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="metaData-detail">
                                        <div>
                                            <span className="meta-title">LTD Print</span>
                                            <p>{props.metaData.ltdInPrint ? formatNumberWithCommas(props.metaData.ltdInPrint) : <>&nbsp;</>}</p>
                                        </div>
                                    </div>
                                </td>



                                <td>
                                    <div className="metaData-detail">
                                        <div>
                                            <span className="meta-title" title="Gross Inventory">Gross Inv</span>
                                            <p>{props.metaData.grossInventory ? formatNumberWithCommas(props.metaData.grossInventory) : <>&nbsp;</>}</p>
                                        </div>
                                    </div>
                                </td>
                                <td><div className="metaData-detail">
                                    <div>
                                        <span className="meta-title">Safety Stk</span>
                                        <p>{props.metaData.safetyStock ? formatNumberWithCommas(props.metaData.safetyStock) : <>&nbsp;</>}</p>
                                    </div>
                                </div>
                                </td>
                                <td>
                                    <div className="metaData-detail">
                                        <span className="meta-title" title="Net Inventory">Net Inv</span>
                                        <p> {props.metaData.netInventory ? formatNumberWithCommas(props.metaData.netInventory) : <>&nbsp;</>}</p>
                                    </div>
                                </td>
                                <td>
                                    <div className="metaData-detail">
                                        <span className="meta-title" title="Bulk Net Inv (not in pack)">Bulk Net</span>
                                        <p> {props.metaData.bulkNet ? formatNumberWithCommas(props.metaData.bulkNet) : <>&nbsp;</>}</p>
                                    </div>
                                </td>
                                <td>
                                    <div className="metaData-detail">
                                        <span className="meta-title" title="Total WIP">Ttl WIP</span>
                                        <p> {formatNumberWithCommas(props.metaData.totalWIP)}</p>
                                    </div>
                                </td>
                                <td>
                                    <div className="metaData-detail">
                                        <span className="meta-title" title="Next WIP">Next WIP</span>
                                        <p> {showFormatDate(props.metaData.nextWIP)}&nbsp;</p>
                                    </div>
                                </td>

                                < td >
                                    <div className="metaData-detail">
                                        <span className="meta-title" >Reissue Date</span>
                                        <p style={{color:"red"} }> {showFormatDate(props.metaData.reissueUSDate)} &nbsp;</p>
                                    </div>
                                </td>
                                <td>
                                    <div className="metaData-detail mb-3" hidden={props.metaData?.statusId == null || !(props.metaData.statusId == 16 || props.metaData.statusId == 23)}>
                                        <div>
                                            {props.metaData.statusId == 23 ? (<span className="meta-title" title="blank">Expiration Date</span>)
                                                : (<span className="meta-title pb-1" title="blank">Agenda Date</span>)}
                                            <span>
                                                {props.metaData.statusId == 23 ? (
                                                    <DatePicker
                                                        portalId="root-portal"
                                                        className="custom-input right-align left-p-input mr-1 mt-2"
                                                        selected={ExpirationDate ?? ''}
                                                        onChange={(date) => expirationDateSelect(date)}
                                                        placeholderText="Select a date"
                                                        dateFormat="MM/dd/yyyy"
                                                        minDate={new Date()}
                                                        maxDate={maxDate}   
                                                            disabled={updatingTitleStatus || !props.isEditable || props?.metaData?.access != 'm'}
                                                    />
                                                ) : (
                                                    <DatePicker
                                                        portalId="root-portal"
                                                        className="custom-input right-align left-p-input mr-1 mt-2"
                                                        selected={AgendaDate ?? ''}
                                                        onChange={(date) => agendaDateSelect(date)}
                                                        placeholderText="Select a date"
                                                        dateFormat="MM/dd/yyyy"
                                                        minDate={new Date()}
                                                        maxDate={maxAgendaDate}
                                                                disabled={updatingTitleStatus || !props.isEditable || props?.metaData?.access != 'm'}
                                                    />
                                                )}
                                            </span>

                                            {props.metaData.overrideUser ?
                                                <span>
                                                    <span className="meta-title" title="blank">Override User</span>
                                                    <span><input type="text" value={props.metaData.overrideUser} style={{ textAlign: "end", paddingRight: "6px", background: "white", width: "100px" }} disabled></input></span>
                                                </span>
                                                :
                                                <></>}
                                        </div>
                                    </div>
                                </td>
                            </>)
                                :
                                null}
                        </tr>
                    </tbody> ): <tbody  >
                        <tr className="mb-1">
                            <td key="title-image" colSpan="3" rowSpan="2" style={{ width: "auto", minWidth: "80px", maxWidth: "150px", paddingLeft: "0" }}></td>


                            <td rowSpan="2" colSpan="2">
                                <div className="metaData-detail">&nbsp;</div>
                            </td>
                            <td rowSpan="2" colSpan="5">
                                <div className="metaData-detail" style={{ color: "red", margin: "auto", fontSize: "20px" }}>Loading Metadata...</div>
                            </td>
                        </tr>
                    </tbody>}
                </table>
            </div>

        </>
    );
}